import { restClient } from '../client';
import { ServiceRate } from '../resources/provider';

export const getProviderCptRates = async (providerId: string) => {
  return await restClient.request<{data: ServiceRate[]}>(`/api/v1/provider/${providerId}/rates`);
};
